<template>
  <div class="side-bar-button-link" @click="$emit('click')">
    <img class="ico" :src="icoUrl" :alt="title"/>
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'SidenavButtonLink',
  props:{
    title:{
      type:String,
      required:true
    },
    ico: {
      type:String,
      required:true
    }
  },
  computed: {
    icoUrl() {
      return require(`@/assets/icons/${this.ico}.png`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.side-bar-button-link {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  fill: $primary;
  font-size: 15px;
  font-weight: 540;

  font-family: "Helvetica", sans-serif;
  padding-left: 20px;
  padding: 20px 0px 20px 20px;
  transition: all 0.2s ease-in-out;

  &:hover, &.route-active {
    cursor: pointer;
    background-color: white;
    color: $primary;
    font-size: 17px;
  }

  span {
    margin-left: 20px;
  }
}
.ico {
  width: 15%;
  height: auto;
  margin-bottom: 10px;
  margin-left: 10px;
}
</style>